
import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from '@emotion/react'
import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme'

/**
 * Simpler version of ModalPage layout to render common error pages that uses v2 ModalHeader and Modal Content
 * MoalPageLayout does not render v1 ModalContent which causes a very narrow content rendered on desktop
 * view.
 */
function ModalPageLayout({ children }) {
  return <ThemeProvider theme={PAYPAL_THEME}>{children}</ThemeProvider>
}

ModalPageLayout.propTypes = {
  children: PropTypes.node,
}

export default ModalPageLayout
